export default __webpack_public_path__ + "static/media/friends.21252fb3.svg";